import { DefaultParams } from '@/api/bbsworld/default';
import { ClientAuth } from '@/classes/ClientAuth';
import { Device } from '@/classes/Device';
import { API_URL, API_VERSION } from '@/constants';
import { HomeContainer } from '@/types';
import { stringify } from 'qs';

export type GetHomeContainersParams = {
  deviceType?: 'TV' | 'MOBILE';
  thumbnailType?: 'IMAGE' | 'LOTTIE';
  contentType?: 'ALL' | 'VIDEO' | 'GAME';
} & DefaultParams;

export async function getHomeContainers(params: GetHomeContainersParams): Promise<Array<HomeContainer>> {
  const response = await fetch(
    `${API_URL}/api/${API_VERSION}/home-containers?${stringify({
      deviceId: Device.uuid,
      ...params,
    })}`,
    {
      method: 'GET',
      headers: ClientAuth.headers,
      credentials: 'include',
    },
  );
  const data = await response.json();

  return data;
}
